import axios from "axios";
import React, { useEffect, useState } from "react";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import "./style.scss";
import { backendUrlImages } from "../../constant/config";

const Certification = () => {
  const [cert, setCert] = useState(null);
  const [hasSurvey, setHasSurvey] = useState(null);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const [currentId, setCurrentId] = useState(null);
  const [speakerId, setSpeakerId] = useState(null);
  const [conferenceId, setConferenceId] = useState(null);

  const [attendanceData, setAttendanceData] = useState(null);
  const [isAttendee, setIsAttendee] = useState(false);
  const [attendeeSurveyDone, setAttendeeSurveyDone] = useState(false);
  const [attendeeHasSurvey, setAttendeeHasSurvey] = useState(null);

  const [form, setForm] = useState({
    q1: "",
    q2: "",
    q3: "",
    q4: "",
    q5: "",
    q6: "",
    q7: "",
    q8: "",
    q9: "",
    q10: "",
  });

  const [attendeeForm, setAttendeeForm] = useState({
    q1: "",
    q2: "",
    q3: "",
    q4: "",
    q5: "",
    q6: "",
    q7: "",
    q8: "",
    q9: "",
    q10: "",
    q11: "",
    q12: "",
  });

  const BaseUrl = "https://eventscons.com/eventbackendnew/api";

  const getFreshToken = () => {
    return localStorage.getItem("token");
  };

  // Backend response ke different possible field names handle karne ke liye
  const getConferenceId = (data) => {
    return (
      data?.conference_id ||
      data?.conferenceId ||
      data?.event_id ||
      data?.eventId ||
      data?.conference?.id ||
      data?.event?.id ||
      null
    );
  };

  useEffect(() => {
    const getData = async () => {
      const freshToken = getFreshToken();

      if (!freshToken) {
        setError("Authentication required. Please login.");
        setLoading(false);
        return;
      }

      const headers = {
        Authorization: `Bearer ${freshToken}`,
        Accept: "application/json",
      };

      try {
        // 1. USER DATA
        const userRes = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/user`,
          { headers }
        );

        const user = userRes?.data?.user;
        const userId = user?.id;

        setCert(user?.certificatePDF);
        setCurrentId(userId);

        console.log("Logged-in user:", user);

        // 2. ATTENDANCE FLOW
        try {
          const attendanceRes = await axios.get(`${BaseUrl}/attendances`, {
            headers,
          });

          console.log("Attendance API response:", attendanceRes?.data);

          const attendance = attendanceRes?.data?.attendance;

          if (
            attendance &&
            attendance.type === "attendance" &&
            Number(attendance.user_id) === Number(userId)
          ) {
            setIsAttendee(true);
            setAttendanceData(attendance);

            const attendeeConferenceId = getConferenceId(attendance);

            console.log(
              "Fetched Attendee Conference ID:",
              attendeeConferenceId
            );

            if (attendeeConferenceId) {
              setConferenceId(attendeeConferenceId);
            }

            // CHECK ATTENDEE SURVEY
            const attendanceId =
              attendance.id || attendance.attendance_id;

            if (attendanceId) {
              try {
                const checkRes = await axios.get(
                  `${BaseUrl}/check-attendee-survey/${attendanceId}`,
                  { headers }
                );

                console.log("Check attendee survey:", checkRes?.data);

                const surveyExists = Boolean(
                  checkRes?.data?.has_survey
                );

                setAttendeeHasSurvey(surveyExists);

                if (surveyExists) {
                  setAttendeeSurveyDone(true);
                }
              } catch (checkErr) {
                console.log(
                  "Check attendee survey error:",
                  checkErr?.response?.data || checkErr.message
                );

                setAttendeeHasSurvey(false);
              }
            }
          }
        } catch (attErr) {
          console.log(
            "Attendance API error:",
            attErr?.response?.data || attErr.message
          );
        }

        // 3. SPEAKER FLOW
        try {
          const speakersRes = await axios.get(`${BaseUrl}/speakers/info`, {
            headers,
          });

          console.log("Full speakers response:", speakersRes?.data);

          const speaker = speakersRes?.data?.speaker;

          const sId = speaker?.speaker_id || speaker?.id;
          const speakerConferenceId = getConferenceId(speaker);

          console.log("Speaker ID found:", sId);
          console.log(
            "Fetched Speaker Conference ID:",
            speakerConferenceId
          );

          if (sId) {
            setSpeakerId(sId);

            /*
             * Speaker API se fetched conference ID state mein save hogi.
             * Yahi ID speaker survey submit ke payload mein jayegi.
             */
            if (speakerConferenceId) {
              setConferenceId(speakerConferenceId);
            }

            const surveyRes = await axios.get(
              `${BaseUrl}/check-speaker-survey/${sId}`,
              { headers }
            );

            console.log("Speaker survey response:", surveyRes?.data);

            setHasSurvey(Boolean(surveyRes?.data?.has_survey));
          } else {
            // Attendee-only user
            setHasSurvey(true);
          }
        } catch (speakerErr) {
          const msg =
            speakerErr?.response?.data?.message ||
            speakerErr?.response?.data?.error ||
            speakerErr.message;

          console.log("Speaker API error:", msg);

          // Attendee-only case
          setHasSurvey(true);
        }
      } catch (err) {
        console.log(
          "Main Error:",
          err?.response?.data || err.message
        );

        setHasSurvey(false);
        setError("Failed to load user data.");
      } finally {
        setLoading(false);
      }
    };

    getData();
  }, []);

  const handleChange = (field) => (e) => {
    setForm((prev) => ({
      ...prev,
      [field]: e.target.value,
    }));
  };

  const handleAttendeeChange = (field) => (e) => {
    setAttendeeForm((prev) => ({
      ...prev,
      [field]: e.target.value,
    }));
  };

  // SUBMIT SPEAKER SURVEY
  const handleSubmitSurvey = async (e) => {
    e.preventDefault();

    const freshToken = getFreshToken();

    if (!freshToken || !currentId || !speakerId) {
      alert("Login ya speaker info missing hai.");
      return;
    }

    if (!conferenceId) {
      alert("Conference ID missing hai.");
      return;
    }

    try {
      setSubmitting(true);

      const payload = {
        speaker_id: speakerId,

        // API se fetched conference ID
        conference_id: conferenceId,

        q1_satisfaction: form.q1 || "Not answered",
        q2_clarity: form.q2 || "Not answered",
        q3_technical_support: form.q3 || "Not answered",
        q4_organization: form.q4 || "Not answered",
        q5_staff_support: form.q5 || "Not answered",
        q6_schedule_management: form.q6 || "Not answered",
        q7_like_experience: form.q7 || "No comments",
        q8_improvement: form.q8 || "No comments",
        q9_future_participation: form.q9 || "Not answered",
        q10_final_comments: form.q10 || "No comments",
      };

      console.log("Submitting Speaker Payload:", payload);

      await axios.post(`${BaseUrl}/speaker-survey`, payload, {
        headers: {
          Authorization: `Bearer ${freshToken}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      alert("Speaker survey submitted successfully!");

      setHasSurvey(true);
    } catch (err) {
      console.error(
        "Speaker Submit Error:",
        err?.response?.data || err.message
      );

      alert(
        err?.response?.data?.message ||
          "Speaker survey submit failed. Check console."
      );
    } finally {
      setSubmitting(false);
    }
  };

  // SUBMIT ATTENDEE SURVEY
  const handleSubmitAttendeeSurvey = async (e) => {
    e.preventDefault();

    const freshToken = getFreshToken();

    if (!freshToken || !attendanceData) {
      alert("Login ya attendance info missing hai.");
      return;
    }

    const attendanceId =
      attendanceData.id || attendanceData.attendance_id;

    const attendeeConferenceId =
      getConferenceId(attendanceData) || conferenceId;

    if (!attendanceId) {
      alert("Attendance ID missing hai.");
      return;
    }

    if (!attendeeConferenceId) {
      alert("Conference ID missing hai.");
      return;
    }

    try {
      setSubmitting(true);

      const payload = {
        attendance_id: attendanceId,
        conference_id: attendeeConferenceId,
        q1_recommend_event: Number(attendeeForm.q1) || 0,
        q2_overall_rating: attendeeForm.q2 || "",
        q3_content_rating: attendeeForm.q3 || "",
        q4_liked_most: attendeeForm.q4 || "",
        q5_disliked: attendeeForm.q5 || "",
        q6_organized: attendeeForm.q6 || "",
        q7_staff_friendly: attendeeForm.q7 || "",
        q8_staff_helpful: attendeeForm.q8 || "",
        q9_info_before_event: attendeeForm.q9 || "",
        q10_event_length: attendeeForm.q10 || "",
        q11_suggestions: attendeeForm.q11 || "",
        q12_anything_else: attendeeForm.q12 || "",
      };

      console.log("Submitting Attendee Payload:", payload);

      await axios.post(`${BaseUrl}/attendee-survey`, payload, {
        headers: {
          Authorization: `Bearer ${freshToken}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      alert("Attendee survey submitted successfully!");

      setAttendeeSurveyDone(true);
      setAttendeeHasSurvey(true);
    } catch (err) {
      console.error(
        "Attendee Submit Error:",
        err?.response?.data || err.message
      );

      alert(
        err?.response?.data?.message ||
          "Attendee survey submit failed. Check console."
      );
    } finally {
      setSubmitting(false);
    }
  };

  // LOADING
  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: 300,
        }}
      >
        <CircularProgress />
        <Typography sx={{ ml: 2 }}>Loading...</Typography>
      </Box>
    );
  }

  // ERROR VIEW
  if (error) {
    return (
      <Box sx={{ maxWidth: 700, mx: "auto", mt: 4 }}>
        <Alert severity="error">{error}</Alert>
      </Box>
    );
  }

  // ATTENDEE SURVEY VIEW
  if (
    isAttendee &&
    !attendeeSurveyDone &&
    attendeeHasSurvey === false
  ) {
    return (
      <Box sx={{ maxWidth: 800, mx: "auto", p: 4 }}>
        <Typography variant="h4" align="center" sx={{ mb: 3 }}>
          📝 Attendee Survey
        </Typography>

        <Box
          component="form"
          onSubmit={handleSubmitAttendeeSurvey}
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 3,
          }}
        >
          <FormControl>
            <FormLabel>
              1. How likely are you to recommend the event to a friend or
              colleague? (1–10)
            </FormLabel>

            <TextField
              type="number"
              inputProps={{ min: 1, max: 10 }}
              value={attendeeForm.q1}
              onChange={handleAttendeeChange("q1")}
            />
          </FormControl>

          <FormControl>
            <FormLabel>
              2. Overall, how would you rate the event?
            </FormLabel>

            <RadioGroup
              value={attendeeForm.q2}
              onChange={handleAttendeeChange("q2")}
            >
              <FormControlLabel
                value="Excellent"
                control={<Radio />}
                label="Excellent"
              />
              <FormControlLabel
                value="Very good"
                control={<Radio />}
                label="Very good"
              />
              <FormControlLabel
                value="Good"
                control={<Radio />}
                label="Good"
              />
              <FormControlLabel
                value="Fair"
                control={<Radio />}
                label="Fair"
              />
              <FormControlLabel
                value="Poor"
                control={<Radio />}
                label="Poor"
              />
            </RadioGroup>
          </FormControl>

          <FormControl>
            <FormLabel>
              3. How would you rate the content/sessions of the event?
            </FormLabel>

            <RadioGroup
              value={attendeeForm.q3}
              onChange={handleAttendeeChange("q3")}
            >
              <FormControlLabel
                value="Excellent"
                control={<Radio />}
                label="Excellent"
              />
              <FormControlLabel
                value="Very good"
                control={<Radio />}
                label="Very good"
              />
              <FormControlLabel
                value="Good"
                control={<Radio />}
                label="Good"
              />
              <FormControlLabel
                value="Fair"
                control={<Radio />}
                label="Fair"
              />
              <FormControlLabel
                value="Poor"
                control={<Radio />}
                label="Poor"
              />
            </RadioGroup>
          </FormControl>

          <TextField
            label="4. What did you like most about the event?"
            multiline
            minRows={3}
            value={attendeeForm.q4}
            onChange={handleAttendeeChange("q4")}
          />

          <TextField
            label="5. What did you dislike about the event?"
            multiline
            minRows={3}
            value={attendeeForm.q5}
            onChange={handleAttendeeChange("q5")}
          />

          <FormControl>
            <FormLabel>
              6. How organized was the event?
            </FormLabel>

            <RadioGroup
              value={attendeeForm.q6}
              onChange={handleAttendeeChange("q6")}
            >
              <FormControlLabel
                value="Extremely organized"
                control={<Radio />}
                label="Extremely organized"
              />
              <FormControlLabel
                value="Very organized"
                control={<Radio />}
                label="Very organized"
              />
              <FormControlLabel
                value="Somewhat organized"
                control={<Radio />}
                label="Somewhat organized"
              />
              <FormControlLabel
                value="Not so organized"
                control={<Radio />}
                label="Not so organized"
              />
              <FormControlLabel
                value="Not at all organized"
                control={<Radio />}
                label="Not at all organized"
              />
            </RadioGroup>
          </FormControl>

          <FormControl>
            <FormLabel>
              7. How friendly was the staff?
            </FormLabel>

            <RadioGroup
              value={attendeeForm.q7}
              onChange={handleAttendeeChange("q7")}
            >
              <FormControlLabel
                value="Extremely friendly"
                control={<Radio />}
                label="Extremely friendly"
              />
              <FormControlLabel
                value="Very friendly"
                control={<Radio />}
                label="Very friendly"
              />
              <FormControlLabel
                value="Somewhat friendly"
                control={<Radio />}
                label="Somewhat friendly"
              />
              <FormControlLabel
                value="Not so friendly"
                control={<Radio />}
                label="Not so friendly"
              />
              <FormControlLabel
                value="Not at all friendly"
                control={<Radio />}
                label="Not at all friendly"
              />
            </RadioGroup>
          </FormControl>

          <FormControl>
            <FormLabel>
              8. How helpful was the staff?
            </FormLabel>

            <RadioGroup
              value={attendeeForm.q8}
              onChange={handleAttendeeChange("q8")}
            >
              <FormControlLabel
                value="Extremely helpful"
                control={<Radio />}
                label="Extremely helpful"
              />
              <FormControlLabel
                value="Very helpful"
                control={<Radio />}
                label="Very helpful"
              />
              <FormControlLabel
                value="Somewhat helpful"
                control={<Radio />}
                label="Somewhat helpful"
              />
              <FormControlLabel
                value="Not so helpful"
                control={<Radio />}
                label="Not so helpful"
              />
              <FormControlLabel
                value="Not at all helpful"
                control={<Radio />}
                label="Not at all helpful"
              />
            </RadioGroup>
          </FormControl>

          <FormControl>
            <FormLabel>
              9. Before the event, how much of the needed information did you
              receive?
            </FormLabel>

            <RadioGroup
              value={attendeeForm.q9}
              onChange={handleAttendeeChange("q9")}
            >
              <FormControlLabel
                value="All"
                control={<Radio />}
                label="All"
              />
              <FormControlLabel
                value="Most"
                control={<Radio />}
                label="Most"
              />
              <FormControlLabel
                value="Some"
                control={<Radio />}
                label="Some"
              />
              <FormControlLabel
                value="A little"
                control={<Radio />}
                label="A little"
              />
              <FormControlLabel
                value="None"
                control={<Radio />}
                label="None"
              />
            </RadioGroup>
          </FormControl>

          <FormControl>
            <FormLabel>
              10. How was the event length?
            </FormLabel>

            <RadioGroup
              value={attendeeForm.q10}
              onChange={handleAttendeeChange("q10")}
            >
              <FormControlLabel
                value="Much too long"
                control={<Radio />}
                label="Much too long"
              />
              <FormControlLabel
                value="Too long"
                control={<Radio />}
                label="Too long"
              />
              <FormControlLabel
                value="About right"
                control={<Radio />}
                label="About right"
              />
              <FormControlLabel
                value="Too short"
                control={<Radio />}
                label="Too short"
              />
              <FormControlLabel
                value="Much too short"
                control={<Radio />}
                label="Much too short"
              />
            </RadioGroup>
          </FormControl>

          <TextField
            label="11. What suggestions do you have to improve future events?"
            multiline
            minRows={3}
            value={attendeeForm.q11}
            onChange={handleAttendeeChange("q11")}
          />

          <TextField
            label="12. Is there anything else you would like to share?"
            multiline
            minRows={3}
            value={attendeeForm.q12}
            onChange={handleAttendeeChange("q12")}
          />

          <Box sx={{ textAlign: "center", mt: 4 }}>
            <Button
              variant="contained"
              type="submit"
              disabled={submitting}
              size="large"
            >
              {submitting
                ? "Submitting..."
                : "Submit & Unlock Certificate"}
            </Button>
          </Box>
        </Box>
      </Box>
    );
  }

  // SPEAKER SURVEY VIEW
  if (!isAttendee && hasSurvey === false) {
    return (
      <Box sx={{ maxWidth: 800, mx: "auto", p: 4 }}>
        <Typography variant="h4" align="center" sx={{ mb: 3 }}>
          🎤 Speaker Survey
        </Typography>

        <Box
          component="form"
          onSubmit={handleSubmitSurvey}
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 3,
          }}
        >
          <FormControl>
            <FormLabel>
              1. How satisfied were you with your overall experience as a
              speaker?
            </FormLabel>

            <RadioGroup
              value={form.q1}
              onChange={handleChange("q1")}
            >
              <FormControlLabel
                value="Very satisfied"
                control={<Radio />}
                label="Very satisfied"
              />
              <FormControlLabel
                value="Satisfied"
                control={<Radio />}
                label="Satisfied"
              />
              <FormControlLabel
                value="Neutral"
                control={<Radio />}
                label="Neutral"
              />
              <FormControlLabel
                value="Dissatisfied"
                control={<Radio />}
                label="Dissatisfied"
              />
              <FormControlLabel
                value="Very dissatisfied"
                control={<Radio />}
                label="Very dissatisfied"
              />
            </RadioGroup>
          </FormControl>

          <FormControl>
            <FormLabel>
              2. How clear were the instructions and communication you received
              before the event?
            </FormLabel>

            <RadioGroup
              value={form.q2}
              onChange={handleChange("q2")}
            >
              <FormControlLabel
                value="Very clear"
                control={<Radio />}
                label="Very clear"
              />
              <FormControlLabel
                value="Clear"
                control={<Radio />}
                label="Clear"
              />
              <FormControlLabel
                value="Somewhat clear"
                control={<Radio />}
                label="Somewhat clear"
              />
              <FormControlLabel
                value="Unclear"
                control={<Radio />}
                label="Unclear"
              />
              <FormControlLabel
                value="Very unclear"
                control={<Radio />}
                label="Very unclear"
              />
            </RadioGroup>
          </FormControl>

          <FormControl>
            <FormLabel>
              3. How would you rate the technical support provided?
            </FormLabel>

            <RadioGroup
              value={form.q3}
              onChange={handleChange("q3")}
            >
              <FormControlLabel
                value="Excellent"
                control={<Radio />}
                label="Excellent"
              />
              <FormControlLabel
                value="Very good"
                control={<Radio />}
                label="Very good"
              />
              <FormControlLabel
                value="Good"
                control={<Radio />}
                label="Good"
              />
              <FormControlLabel
                value="Fair"
                control={<Radio />}
                label="Fair"
              />
              <FormControlLabel
                value="Poor"
                control={<Radio />}
                label="Poor"
              />
            </RadioGroup>
          </FormControl>

          <FormControl>
            <FormLabel>
              4. How organized was the event overall?
            </FormLabel>

            <RadioGroup
              value={form.q4}
              onChange={handleChange("q4")}
            >
              <FormControlLabel
                value="Excellent"
                control={<Radio />}
                label="Excellent"
              />
              <FormControlLabel
                value="Very good"
                control={<Radio />}
                label="Very good"
              />
              <FormControlLabel
                value="Good"
                control={<Radio />}
                label="Good"
              />
              <FormControlLabel
                value="Fair"
                control={<Radio />}
                label="Fair"
              />
              <FormControlLabel
                value="Poor"
                control={<Radio />}
                label="Poor"
              />
            </RadioGroup>
          </FormControl>

          <FormControl>
            <FormLabel>
              5. How would you rate the staff support during the event?
            </FormLabel>

            <RadioGroup
              value={form.q5}
              onChange={handleChange("q5")}
            >
              <FormControlLabel
                value="Extremely supportive"
                control={<Radio />}
                label="Extremely supportive"
              />
              <FormControlLabel
                value="Very supportive"
                control={<Radio />}
                label="Very supportive"
              />
              <FormControlLabel
                value="Somewhat supportive"
                control={<Radio />}
                label="Somewhat supportive"
              />
              <FormControlLabel
                value="Not so supportive"
                control={<Radio />}
                label="Not so supportive"
              />
              <FormControlLabel
                value="Not supportive at all"
                control={<Radio />}
                label="Not supportive at all"
              />
            </RadioGroup>
          </FormControl>

          <FormControl>
            <FormLabel>
              6. Did you feel your session was well scheduled and managed?
            </FormLabel>

            <RadioGroup
              value={form.q6}
              onChange={handleChange("q6")}
            >
              <FormControlLabel
                value="Yes"
                control={<Radio />}
                label="Yes"
              />
              <FormControlLabel
                value="Somewhat"
                control={<Radio />}
                label="Somewhat"
              />
              <FormControlLabel
                value="No"
                control={<Radio />}
                label="No"
              />
            </RadioGroup>
          </FormControl>

          <TextField
            label="7. What did you like about your experience as a speaker?"
            multiline
            minRows={3}
            value={form.q7}
            onChange={handleChange("q7")}
          />

          <TextField
            label="8. What challenges did you face or what could be improved?"
            multiline
            minRows={3}
            value={form.q8}
            onChange={handleChange("q8")}
          />

          <FormControl>
            <FormLabel>
              9. Would you participate as a speaker again in future events?
            </FormLabel>

            <RadioGroup
              value={form.q9}
              onChange={handleChange("q9")}
            >
              <FormControlLabel
                value="Definitely yes"
                control={<Radio />}
                label="Definitely yes"
              />
              <FormControlLabel
                value="Probably yes"
                control={<Radio />}
                label="Probably yes"
              />
              <FormControlLabel
                value="Not sure"
                control={<Radio />}
                label="Not sure"
              />
              <FormControlLabel
                value="Probably no"
                control={<Radio />}
                label="Probably no"
              />
              <FormControlLabel
                value="Definitely no"
                control={<Radio />}
                label="Definitely no"
              />
            </RadioGroup>
          </FormControl>

          <TextField
            label="10. Any final comments or suggestions?"
            multiline
            minRows={3}
            value={form.q10}
            onChange={handleChange("q10")}
          />

          <Box sx={{ textAlign: "center", mt: 4 }}>
            <Button
              variant="contained"
              type="submit"
              disabled={submitting}
              size="large"
            >
              {submitting
                ? "Submitting..."
                : "Submit & Unlock Certificate"}
            </Button>
          </Box>
        </Box>
      </Box>
    );
  }

  // CERTIFICATE VIEW
  return (
    <Box sx={{ maxWidth: 900, mx: "auto", p: 4 }}>
      <Typography variant="h4" align="center" sx={{ mb: 3 }}>
        🎉 Your Certificate
      </Typography>

      <Typography align="center">
        Survey already completed.
      </Typography>

      {cert ? (
        <Box sx={{ textAlign: "center", mt: 3 }}>
          <iframe
            src={`${backendUrlImages}${cert}`}
            width="100%"
            height="600"
            style={{ borderRadius: 12 }}
            title="Certificate"
          />

          <Button
            href={`${backendUrlImages}${cert}`}
            download
            variant="contained"
            sx={{ mt: 3 }}
          >
            Download Certificate
          </Button>
        </Box>
      ) : (
        <Alert severity="info" sx={{ mt: 3 }}>
          No certificate available.
        </Alert>
      )}
    </Box>
  );
};

export default Certification;